/**
 * Utilitaires pour le formatage des messages du chat N8N
 */

export interface OrderData {
  order?: string;
  orderId?: string;
  id?: string;
  orderInternalId?: string;
  date?: string;
  orderDate?: string;
  orderPriceInformations?: {
    totalOrderPrice?: number;
  };
  montant?: number;
  amount?: number;
  nbProducts?: number;
  'nb products'?: number;
}

export interface ProductOrder {
  date: string;
}

/**
 * Formate la date de commande
 */
export function formatOrderDate(dateString: string): string {
  if (!dateString) return '';
  
  // Si c'est déjà formaté (ancien format)
  if (!dateString.includes('T')) {
    return dateString;
  }
  
  // Nouveau format ISO, extraire juste la date
  return dateString.split('T')[0];
}

/**
 * Récupère le montant de la commande selon différents formats
 */
export function getOrderAmount(order: OrderData): number {
  // Nouveau format : priorité à orderPriceInformations.totalOrderPrice
  if (order.orderPriceInformations && order.orderPriceInformations.totalOrderPrice !== undefined) {
    return order.orderPriceInformations.totalOrderPrice;
  }
  // Fallback sur montant
  if (order.montant !== undefined) {
    return order.montant;
  }
  // Ancien format
  return order.amount || 0;
}

/**
 * Calcule la dernière date de commande depuis le tableau orders
 */
export function getLastOrderDate(orders?: ProductOrder[]): string | null {
  if (!orders || !Array.isArray(orders) || orders.length === 0) {
    return null;
  }
  
  // Trier les commandes par date décroissante et prendre la première
  const sortedOrders = orders.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const lastOrderDate = sortedOrders[0].date;
  
  // Extraire seulement la partie date (YYYY-MM-DD) du format ISO
  return lastOrderDate.split('T')[0];
}

/**
 * Génère un identifiant de session unique
 */
export function generateSessionId(cartId?: string): string {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substr(2, 9);
  const cartPart = cartId ? cartId.substr(-8) : 'nocart';
  return `chat_${timestamp}_${random}_${cartPart}`;
}

/**
 * Génère la clé de stockage pour une session
 */
export function getSessionStorageKey(storeId: string, cartId?: string): string {
  return `chat_session_${storeId}_${cartId || 'default'}`;
} 